import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { AlertDisplayFieldProps } from './AlertDisplayFieldProps';

const useStyles = makeStyles((theme) => createStyles({
	label: {
		fontWeight: 600,
		marginRight: theme.spacing(1),
	},
	text: {
		fontWeight: 400,
	},
	root: {
		display: 'flex',
		flexDirection: 'row',
		marginRight: theme.spacing(2),
	},
}));

export const AlertDisplayField = ({
	label,
	children,
	...rest
}: AlertDisplayFieldProps) => {
	const classes = useStyles();

	return (
		<Box className={classes.root} {...rest}>
			{label &&
				<Typography
					className={classes.label}
					variant="body1"
				>
					{label}
				</Typography>
			}
			<Typography
				className={classes.text}
				variant="body1"
			>
				{children}
			</Typography>
		</Box>
	);
};
